import PhotoList from "./PhotoList";

export default PhotoList;
